import { createAction, props } from '@ngrx/store';

export const setBusinessAccountParentKey = createAction(
  '[Business Account Parent Key] Set Business Account Parent Key',
  props<{ businessAccountParentKey: AuthModel }>()
);
